/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, August 12th 2022, 11:36:24 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import ProgressiveImage from "react-progressive-graceful-image";

type ImageProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const Image = ({ src, ...imageProps }: ImageProps) => {
  return (
    <ProgressiveImage src={src} placeholder="/img/loading.svg">
      {(src: string, loading: boolean) => (
        <img
          {...imageProps}
          src={src}
          className={loading ? "image-loader" : imageProps?.className}
          style={imageProps?.style}
          alt=""
        />
      )}
    </ProgressiveImage>
  );
};
